import { Component } from '@angular/core';
import { ShowComponent } from 'src/app/common/component/show.component';

@Component({
	selector: 'app-timetable',
	templateUrl: './timetable.component.html',
	styleUrls: ['./timetable.component.css'],
})
export class TimetableComponent extends ShowComponent {
	protected parentComponent = 'timetable';
	protected apiUrl = '';
	timetableId = this.route.snapshot.params.id;
	data = {
		id: null,
		side: null,
		seasons: null,
		status: null,
	};
	statusName = '';
	sideName = '';
	private questionApproveSubscription;

	protected getApiUrl(): string {
		return '/tourismTimetable/' + this.data.id;
	}

	protected convertData(data) {
		this.sideName = data.side == 'departure' ? 'Wyjazd' : 'Powrót';
		this.setStatusName();
		return data;
	}

	private setStatusName() {
		switch (this.data.status) {
			case '1':
				this.statusName = 'Nowy';
				break;
			case '2':
				this.statusName = 'Zatwierdzony';
				break;
		}
	}

	approveAsk() {
		this.question.ask('Czy na pewno zmienić?', 'approveAsk');
		this.questionApproveSubscription = this.question.status.subscribe((result) => {
			if (result.dialogId != 'approveAsk') {
				return;
			}
			if (!result.result) {
				return;
			}
			this.data.status = this.data.status == '1' ? '2' : '1';
			this.api.command(
				'/tourismTimetable/',
				{ cmd: 'approve', id: this.data.id, status: this.data.status },
				(result, error) => {
					if (error) {
						return;
					}
					this.setStatusName();
					this.infobox.success('Zapisano');
				},
			);
		});
	}
}
